var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDuplicate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.313a1.2 1.2 0 0 1-.875-.375 1.2 1.2 0 0 1-.375-.875V4.5h1.25v12.563h9.875v1.25H3.75Zm2.5-2.5a1.2 1.2 0 0 1-.875-.376A1.2 1.2 0 0 1 5 14.563V2.896a1.2 1.2 0 0 1 .375-.875 1.2 1.2 0 0 1 .875-.375h9.167a1.2 1.2 0 0 1 .875.375c.25.25.375.541.375.875v11.666a1.2 1.2 0 0 1-.375.876 1.2 1.2 0 0 1-.875.374H6.25Zm0-1.25h9.167V2.896H6.25v11.666Zm0 0V2.896v11.666Z"
  })));
};
export { SvgDuplicate as ReactComponent };